var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrinterBlack24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "85408B60-F935-4D03-9A37-2D9A00F58CFB_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Voucher---Options",
    transform: "translate(-23.000000, -52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Printer_Black-24px",
    transform: "translate(24.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    points: "5.5 0.5 18.5 0.5 18.5 4.5 5.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,17.5 L3.5,17.5 C1.85,17.5 0.5,16.15 0.5,14.5 L0.5,4.5 L23.5,4.5 L23.5,14.5 C23.5,16.15 22.15,17.5 20.5,17.5 L18.5,17.5",
    id: "Stroke-5",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    stroke: "#000000",
    strokeWidth: 2,
    fill: "#FFFFFF",
    points: "5.5 13.5 18.5 13.5 18.5 21.5 5.5 21.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,8 C21,8.552285 20.552285,9 20,9 C19.447715,9 19,8.552285 19,8 C19,7.447715 19.447715,7 20,7 C20.552285,7 21,7.447715 21,8 Z",
    id: "Fill-7",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinterBlack24Px);
export default __webpack_public_path__ + "static/media/Icon_Printer_Black-24px.884fbd05fc5c3b7a953ce9470e920e64.svg";
export { ForwardRef as ReactComponent };